// @flow
import React from "react";
import { Form } from "react-bootstrap";

// constants
import * as layoutConstants from "../../data/layout";

/**
 * Componente para el color del tema
 *
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.changeLayoutColorScheme - Función para cambiar el color del tema
 * @param {String} props.layoutColor - Color del tema
 * @param {Object} props.layoutConstants - Constantes de color del tema
 * @returns {JSX.Element} Componente de React
 */
const LayoutColor = ({
  changeLayoutColorScheme,
  layoutColor,
  layoutConstants,
}) => {
  return (
    <>
      <h5 className="mt-4">Color del Tema</h5>

      <hr className="mt-1" />

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          onChange={(e) => changeLayoutColorScheme(e.target.value)}
          name="layout-color"
          value={layoutConstants.LAYOUT_COLOR_LIGHT}
          id="light-mode"
          checked={layoutColor === layoutConstants.LAYOUT_COLOR_LIGHT}
        />
        <Form.Check.Label htmlFor="vertical-layout">Claro</Form.Check.Label>
      </Form.Check>

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          onChange={(e) => changeLayoutColorScheme(e.target.value)}
          name="layout-color"
          value={layoutConstants.LAYOUT_COLOR_DARK}
          id="dark-mode"
          checked={layoutColor === layoutConstants.LAYOUT_COLOR_DARK}
        />
        <Form.Check.Label htmlFor="horizontal-layout">Oscuro</Form.Check.Label>
      </Form.Check>
    </>
  );
};

export default LayoutColor;
